import { ViewArticleAltKeys as altKey } from '../../../../../../services/analytics/formatters/alt-meta-keys'
import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { AttributeFormatter } from '../../formatters/attribute'
import { PageEvents } from '../../page-events'
import { MparticleEvent } from '../mparticle-event'

const mParticleEvents: any = new PageEvents()

export class ArticleView extends MparticleEvent {

    public attributeFormatter = new AttributeFormatter()
    /**
     * Handle a story page load event
     */
    public handle(): void {

        /**
         * @var attrs will be different for each
         * events
         *
         * there are events which has will have attributes
         * both from dom element and page meta properties
         */

        const attrs = [
            key.ARTICLE_ID,
            key.AUTHORS,
            key.CATEGORY,
            key.CANONICAL_PATH,
            key.CUR_PAGE,
            key.DEBUG,
            key.DISTRIBUTOR,
            key.DOMAIN,
            key.EXCERPT,
            key.FORMAT,
            key.GLOBAL_ID,
            key.HEADLINE,
            key.IS_ORIGINAL,
            key.KLNGO_CATEGORY,
            key.KLNGO_ENTITY,
            key.META_DESC,
            key.META_ROBOT,
            key.META_TAG,
            key.MOD_DATE,
            key.MOD_TIME,
            key.MP_ID,
            key.NEWS_KEYWRD,
            key.ORIGINAL_ID,
            key.PAYWALL,
            key.PUB_DATE,
            key.PUB_TIME,
            key.SLUG,
            key.SUB_SEC,
            key.SUB_SEC_2,
            key.SUB_SEC_3,
            key.TITLE,
            key.TYPE,
            key.VENDOR,
            key.VID_IN_PAGE,
            key.WRD_CNT
        ]

        const altAttrs = {
            [key.ARTICLE_ID]: altKey.ARTICLE_ID,
            [key.AUTHORS]: altKey.AUTHORS,
            [key.CATEGORY]: altKey.CATEGORY,
            [key.ORIGINAL_ID]: altKey.ORIGINAL_ID,
            [key.TITLE]: altKey.TITLE,
            [key.SUB_SEC]: altKey.SUB_SEC
        }

        const data = this.attributeFormatter.format(attrs, this.metaProperties || {}, altAttrs)

        this.attributeFormatter.mParticleId().then((mpId) => {
            mParticleEvents.logEvent(
                PageEvents.mpEventName.ViewArticle,
                PageEvents.mpEventType.Navigation,
                {...data, ...{[key.MP_ID]: String(mpId)}},
                {'Google.NonInteraction': true}
            )
        }, () => {
            mParticleEvents.logEvent(
                PageEvents.mpEventName.ViewArticle,
                PageEvents.mpEventType.Navigation,
                data,
                {'Google.NonInteraction': true}
            )
        })
    }
}
